export default __webpack_public_path__ + "static/media/logo.555038db.jpg";